/** Presentation capabilities. These never confer authority; server routes recheck every command. */
import type { Operation } from "./transport";
export const screenOperations: Record<string, readonly Operation[]> = {
  B01: [],
  B02: [],
  B03: ["cart.save", "gifting.save", "gifting.remove", "custom.request"],
  B04: ["gifting.save", "gifting.remove"],
  B05: ["gifting.save", "gifting.remove", "gifting.registry.save","gifting.collection.create","gifting.collection.update","gifting.collection.share","gifting.collection.unshare","gifting.collection.delete","gifting.collection.adopt"],
  B06: ["gifting.claim", "gifting.registry.save", "gifting.teaser", "gifting.teaser.consent", "gifting.schedule.consent", "cart.save"],
  B07: ["growth.cart.consent","growth.cart.withdraw","checkout.address.save", "checkout.context.save", "cart.save", "checkout.prepare", "checkout.freeze"],
  B08: [
    "cart.save",
    "checkout.prepare",
    "checkout.address.save",
    "checkout.context.save",
    "checkout.freeze",
    "checkout.confirm",
    "checkout.fund",
    "checkout.cancel",
    "delegation.prepare",
    "delegation.confirm",
  ],
  B09: ["digital.manifest.map", "digital.proof.manage", "digital.grant.manage", "gifting.slip", "gifting.teaser", "gifting.schedule", "gifting.schedule.media"],
  B10: ["identity.claim"],
  B11: ["custom.request", "custom.accept", "custom.renew", "custom.preserve", "cart.save"],
  B12: [
    "conversation.send",
    "conversation.draft",
    "conversation.report",
    "conversation.preference",
    "conversation.block",
    "conversation.schedule",
    "conversation.registerAttachment",
  ],
  B13: ["aftersales.eligibility", "case.submit", "case.refund", "aftersales.allocate", "aftersales.refund"],
  B14: ["case.submit", "case.refund", "aftersales.allocate", "aftersales.refund"],
  B15: ["purchase.review"],
  B16: [],
  A01: ["identity.enroll", "identity.recover", "identity.claim", "identity.sellerSetup"],
  A02: [
    "identity.stepUp",
    "identity.claim",
    "identity.preferences", "identity.buyerPreferences",
    "delegation.prepare",
    "delegation.confirm",
  ],
  A03: [
    "privacy.consent",
    "privacy.export",
    "privacy.delete",
    "privacy.resume",
  ],
  A04: [
    "identity.stepUp",
    "delegation.revoke",
    "delegation.prepare",
    "delegation.confirm",
  ],
  S01: ["identity.enroll", "identity.submit"],
  S02: ["workspace.queue", "workspace.pause"],
  S03: [
    "catalog.discovery.declare",
    "catalog.draft.create",
    "catalog.shop",
    "catalog.draft",
    "workspace.importPreview",
    "workspace.importCommit",
    "workspace.importRollback",
    "workspace.export",
  ],
  S04: [
    "catalog.discovery.declare",
    "digital.listing.upload", "digital.listing.scan", "digital.listing.declare",
    "catalog.stock.set",
    "catalog.draft",
    "catalog.publish",
    "delegation.prepare",
    "delegation.confirm",
  ],
  S05: ["catalog.shop.vacation", "catalog.shop.renew", "catalog.shop", "workspace.pause", "catalog.shop.profile","catalog.shop.policy"],
  S06: ["digital.proof.manage", "custom.version", "custom.preserve", "fulfillment.reserve"],
  S07: [
    "fulfillment.ship",
    "fulfillment.quote",
    "fulfillment.label",
    "fulfillment.labelRefund",
  ],
  S08: [],
  S09: [
    "aftersales.eligibility",
    "aftersales.refund",
    "aftersales.allocate",
    "delegation.prepare",
    "delegation.confirm",
  ],
  S10: ["growth.owner.enroll","growth.promotion.create","growth.promotion.state","growth.offer.apply","growth.placement.place","workspace.analytics", "growth.stack", "growth.spend", "growth.subscription.entitlement", "growth.campaign.activate", "growth.campaign.update"],
  S11: [
    "conversation.send",
    "conversation.draft",
    "conversation.report",
    "conversation.preference",
    "conversation.block",
    "conversation.schedule",
    "conversation.registerAttachment",
  ],
  S12: ["trust.appeal.submit"],
  O01: [
    "case.submit",
    "case.review",
    "conversation.send",
    "conversation.report",
  ],
  O02: ["trust.review", "trust.restrict", "trust.appeal.review"],
  O03: [
    "operations.reconcile",
    "case.refund",
    "aftersales.refund",
    "aftersales.allocate",
    "delegation.prepare",
    "delegation.confirm",
  ],
  O04: ["operations.policyPropose", "operations.policyApprove"],
  O05: ["operations.reconcile", "operations.freeze", "operations.restore"],
  O06: ["privacy.resume"],
  I01: [],
};
